export default "<ion-searchbar autocomplete=\"auto\" (ionChange)=\"onChange($event)\"></ion-searchbar>";